// Klimb brand + design-token mirrors.
//
// The CSS token system in styles/tokens.css is the source of truth. These
// TS exports name the same tokens so code can reference them without
// hardcoding raw values. Prefer `var(--c-fg)` over `KlimbTokens.fg` in
// styles; the TS side exists for places where a string literal is needed
// (e.g. SVG fills, MUI overrides).

export const KlimbBrand = {
  name: 'Klimb',
  wordmark: 'klimb',
  tagline: 'A white-label academy, designed to disappear.',
  promise: 'One token system. Three product surfaces. Six starter themes.',
} as const

export const KlimbTokens = {
  bg: 'var(--c-bg)',
  bgElev: 'var(--c-bg-elev)',
  bgSunk: 'var(--c-bg-sunk)',
  fg: 'var(--c-fg)',
  fgMuted: 'var(--c-fg-muted)',
  fgSubtle: 'var(--c-fg-subtle)',
  border: 'var(--c-border)',
  borderStrong: 'var(--c-border-strong)',
  accent: 'var(--c-accent)',
  accentFg: 'var(--c-accent-fg)',
  accentSoft: 'var(--c-accent-soft)',
  warn: 'var(--c-warn)',
  danger: 'var(--c-danger)',
  ok: 'var(--c-ok)',
  info: 'var(--c-info)',
  fontDisplay: 'var(--font-display)',
  fontSans: 'var(--font-sans)',
  fontMono: 'var(--font-mono)',
} as const

export type KlimbTokenName = keyof typeof KlimbTokens

// Theme registry: each entry resolves to the class string(s) SurfaceRoot
// applies. Tech-dark is two classes because the dark mode is a modifier
// on the tech theme — we model it explicitly instead of hiding a space-
// separated string behind a single key.
export const KlimbThemes = {
  klimb: '',
  klimbDark: 'klimb-dark',
  academy: 'theme-academy',
  creator: 'theme-creator',
  bold: 'theme-bold',
  kids: 'theme-kids',
  corp: 'theme-corp',
  tech: 'theme-tech',
  techDark: 'theme-tech dark',
  // Dark starter themes (KAT — header/theme customization). Each is a
  // self-contained dark palette, not a modifier on a light theme.
  midnight: 'theme-midnight',
  nocturne: 'theme-nocturne',
} as const

export type KlimbTheme = keyof typeof KlimbThemes
